/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_IntroInputs */

const en_guide_json_rest_api_intro = /** @type {(inputs: Guide_Json_Rest_Api_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON is the lingua franca of REST APIs. Nearly every modern web API sends and receives data in JSON format. This guide explains how JSON fits into the REST architecture, covering headers, request bodies, response structures, and practical tips for working with API data.`)
};

const ko_guide_json_rest_api_intro = /** @type {(inputs: Guide_Json_Rest_Api_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON은 REST API의 공용어입니다. 거의 모든 현대 웹 API는 JSON 포맷으로 데이터를 보내고 받습니다. 이 가이드는 REST 아키텍처에서 JSON이 어떻게 사용되는지 설명하며, 헤더, 요청 본문, 응답 구조, API 데이터 작업을 위한 실용적인 팁을 다룹니다.`)
};

const ja_guide_json_rest_api_intro = /** @type {(inputs: Guide_Json_Rest_Api_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONはREST APIの共通言語です。ほぼすべての現代的なWeb APIはJSONフォーマットでデータを送受信します。このガイドでは、RESTアーキテクチャにおけるJSONの役割を、ヘッダー、リクエストボディ、レスポンス構造、APIデータの実践的なヒントとともに解説します。`)
};

/**
* | output |
* | --- |
* | "JSON is the lingua franca of REST APIs. Nearly every modern web API sends and receives data in JSON format. This guide explains how JSON fits into the REST a..." |
*
* @param {Guide_Json_Rest_Api_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_intro = /** @type {((inputs?: Guide_Json_Rest_Api_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_intro(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_intro(inputs)
	return ja_guide_json_rest_api_intro(inputs)
});